
// TODO: Check this GLOBAL "let".  It is not good for rerenders! as seen in the global useLogMe which caused serius issues.
//       Consider instead a context provider with useState.
//       Or, an object as alternative like `const kbdReg = { isRegistered: false, otherProps: 'etc..' };`  This should not cause rerenders as it keeps the same objecty ref!
let keyboardRegistered = false;

const keysPressed = new Set();
export const isKeyboardAdded = () => Boolean(keyboardRegistered);
export const keyboardAdded = () => keyboardRegistered = true;
export const keyboardRemoved = () => keyboardRegistered = false;
export const keyPressed = (keyName) => keysPressed.add(keyName);
export const keyReleased = (keyName) => keysPressed.delete(keyName);
